
export const GET_USER_SUCCESS="GET_USER_SUCCESS";
export const GET_USER_LOADING="GET_USER_LOADING";
export const GET_USER_FAILURE="GET_USER_FAILURE";
export const PATCH_USER = "PATCH_USER";
export const DELETE_USER = "DELETE_USER";

export const GET_SINGLE_USER_SUCCESS="GET_SINGLE_USER_SUCCESS";
export const GET_SINGLE_USER_REQUEST="GET_SINGLE_USER_REQUEST";
export const GET_SINGLE_USER_FAILURE="GET_SINGLE_USER_FAILURE";

export const DELETE_SINGLE_USER_REQUEST = 'DELETE_SINGLE_USER_REQUEST';
export const DELETE_SINGLE_USER_SUCCESS = 'DELETE_SINGLE_USER_SUCCESS';
export const DELETE_SINGLE_USER_FAILURE = 'DELETE_SINGLE_USER_FAILURE';
